import { Grid, makeStyles, TextField, useMediaQuery } from "@material-ui/core";
import { Stack } from "@mui/material";
import AgapeIcon from "../../../../common/icons/AgapeIcon";
import React from "react";
import clsx from "clsx";
import InputAdornment from "@mui/material/InputAdornment";
import AmoumtComponent from "./amountCom";
import { Formik } from "formik";
import RoundButton from "../../../../common/button/RoundButton";
import { useRouter } from "next/router";
import { postApiService } from "../../../../../services/AgapeAPI";
import * as Yup from "yup";
import Cookies from "universal-cookie/lib";
import requerd from "../../../../../public/assets/images/requerd.svg";
import { emailRegex } from "../../../../../helpers/validators";
import { useTheme } from "@material-ui/core/styles";
import useError from "../../../../../helpers/useError";
import Image from "next/image";

const SignupSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^(?!.*[\u0600-\u06FF])/, "First Name Can Not Be Persian")
    .min(3, "First Name must be at least 3 characters long")
    .required("First Name is required"),
  lastName: Yup.string()
    .min(3, "Last Name must be at least 3 characters long")
    .matches(/^(?!.*[\u0600-\u06FF])/, "Last Name Can Not Be Persian")

    .required("Last Name is required"),
  phone: Yup.string()
    .matches(
      "^[(00)|(+)]{1}[0-9\\s.\\/-]{11,20}$",
      "Mobile Number Is Not Valid"
    )
    .required("Please enter a valid Phone Number"),
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "Email Address Is Not Valid"),
  address: Yup.string()
    .min(3, "Address must be at least 3 characters long")
    .required("Address is required")
    .matches(/^(?!.*[\u0600-\u06FF])/, " Address Can Not Be Persian"),
  city: Yup.string()
    .required(" City is required")
    .matches(/^(?!.*[\u0600-\u06FF])/, " City Can Not Be Persian")
    .min(3, "City must be at least 3 characters long"),
  country: Yup.string()
    .required("Country is required")
    .matches(/^(?!.*[\u0600-\u06FF])/, " Country Can Not Be Persian")
    .min(3, "Country must be at least 3 characters long"),
  postalcode: Yup.string()
    .required("Postal Code is required")
    .min(3, "Please enter a valid Postal Code"),
});
const useStyles = makeStyles((theme) => ({
  err: {
    display: "flex",
    width: "100%",
    justifyContent: "right",
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "red",
  },

  labelStyle: {
    textAlign: "right",
    fontWeight: "bold",
    marginBottom: "3px",
    fontFamily: "vazir-bold",
  },

  inputStyle: {
    background: "white",
    border: "1px solid #B6B3B3",
    borderRadius: "5px",
    outline: "none",
    padding: "10px",
    boxSizing: "border-box",
    textAlign: "right",
    "&::placeholder": {
      fontSize: "12px",
      fontFamily: "vazir",
    },
  },
  width380: {
    width: "380px",
    "@media only screen and (max-width: 600px)": {
      width: "90%",
    },
    "@media only screen and (min-width: 600px) and (max-width: 1278px)": {
      width: "98%",
    },
  },
  width222: {
    width: "222px",
    "@media only screen and (max-width: 600px)": {
      width: "90%",
    },
    "@media only screen and (min-width: 600px) and (max-width: 1278px)": {
      width: "95%",
    },
  },
  width92: {
    width: "92%",
    "@media only screen and (max-width: 600px)": {
      width: "90%",
    },
    "@media only screen and (min-width: 600px) and (max-width: 1278px)": {
      width: "99%",
    },
  },

  errorStyle: {
    color: "red",
    fontSize: "12px",
    display: "flex",
    justifyContent: "end",
  },

  disabledsubmitButton: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
    display: "flex",
    justifyContent: "center",
    borderRadius: "10px",
    width: "200px",
    marginTop: "40px",
  },
  formStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "30px",
  },

  gridContainerStyle: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    width: "100%",
    maxWidth: "600px",
  },

  gridItemStyle: {
    display: "flex",
    flexDirection: "column",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
      justifyContent: "center",
    },
  },

  gridFullWidthItemStyle: {
    display: "flex",
    flexDirection: "column",
    gridColumn: "span 2",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
      justifyContent: "center",
    },
  },
  root: {
    borderRadius: "5px",
    color: "#acacac",
    alignSelf: "center",
    width: "222px",

    height: "40px",

    "& .MuiInputBase-root": {
      dir: "ltr",
      height: "58px",
      width: "100%",
      margin: "auto",
      border: "2px solid #B6B3B3",
      fontFamily: "vazir-bold",
      borderRadius: "30px",
    },
    "& .MuiOutlinedInput-input": {},
    "@media only screen and (max-width: 600px)": {
      width: "95%",
      marginTop: "10px",
    },
  },
  submit: {
    display: "flex",
    justifyContent: "center",
    width: "380px",
    marginTop: "40px",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      marginTop: 0,
    },
    "@media only screen and (min-width: 600px) and (max-width: 1278px)": {
      width: "100%",
    },
  },
  disableSubmit: {
    backgroundColor: "#B6B3B3",
    border: "none",
    display: "flex",
    justifyContent: "center",
    width: "380px",
    marginTop: "40px",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      marginTop: 0,
    },
    "@media only screen and (min-width: 600px) and (max-width: 1278px)": {
      width: "100%",
    },
  },
}));
const ArzPayment = () => {
  const classes = useStyles();
  const router = useRouter();
  const [value, setValue] = React.useState(5);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const cookies = new Cookies();

  const isLogin = cookies.get("isLoggedIn") === "1";
  const errorHook = useError();
  const setError = (err) => errorHook(err);
  return (
    <Stack
      style={{
        backgroundColor: "#FFFFFF",
        boxShadow: " 0px 0px 14px 2px rgba(0,0,0,0.1)",
        borderRadius: "10px",
        marginTop: "15px",
        height: isMobile ? "840px" : "723px",

        paddingTop: isMobile ? 0 : "10%",
        paddingLeft: isMobile ? 0 : "10%",
        paddingRight: isMobile ? 0 : "15%",
      }}
    >
      <Stack
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Stack>
          <TextField
            value={value}
            id="demo-helper-text-misaligned"
            variant="outlined"
            className={clsx(classes.root)}
            onChange={(e) => setValue(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <AgapeIcon
                    icon="logo-euro"
                    size="20px"
                    color="rgba(21, 52, 42, 0.72)"
                  />
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <AmoumtComponent setValue={setValue} />
      </Stack>

      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          address: "",
          country: "",
          city: "",
          password: "",
          postalcode: "",
        }}
        validationSchema={SignupSchema}
        onSubmit={(values) => {
          if (isLogin || !props.data?.require_login) {
            const ROOT = "pay/dedicate-payments";
            const data = {
              amount: value,
              mobile: values.phone,
              organization_id: router.query.id,
              via: "yekpay",
              email: values.email,
              firstName: values.firstName,
              lastName: values.lastName,
              address: values.address,
              postalCode: values.postalcode,
              country: values.country,
              city: values.city,
            };
            postApiService(ROOT, data)
              .then((res) => {
                window.open(res.data, "_self");
              })
              .catch((ex) => {
                if (ex.response.status === 403) {
                  localStorage.setItem(
                    "failed_payment_for_auth",
                    JSON.stringify({
                      url: ROOT,
                      data,
                    })
                  );
                  router.replace(`/login?from=${router.asPath}`);
                } else {
                  setError(ex);
                }
              });
          } else {
            const ROOT = "pay/dedicate-payments";

            const data = {
              amount: value,
              mobile: values.phone,
              organization_id: router.query.id,
              via: "yekpay",
              email: values.email,
              firstName: values.firstName,
              lastName: values.lastName,
              address: values.address,
              postalCode: values.postalcode,
              country: values.country,
              city: values.city,
            };

            localStorage.setItem(
              "failed_payment_for_auth",
              JSON.stringify({
                url: ROOT,
                data,
              })
            );
            router.replace(`/login?from=${router.asPath}`);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit} className={classes.formStyle}>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12} lg={6} md={6}>
                <div item className={classes.gridItemStyle}>
                  <label
                    htmlFor="firstName"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="Add Your First Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.firstName}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.firstName && touched.firstName && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.firstName}
                    </div>
                  )}
                </div>
              </Grid>

              <Grid item sm={6} xs={12} lg={6} md={6}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="lastName"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Add Your Last Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lastName}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.lastName && touched.lastName && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.lastName}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={6} xs={12} lg={6} md={6}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="email"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="EX:email@email.com"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.email && touched.email && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.email}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={6} xs={12} lg={6} md={6}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="phone"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="EX:+989123456789"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.phone && touched.phone && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.phone}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.gridFullWidthItemStyle}>
                  <label
                    htmlFor="address"
                    className={clsx(classes.labelStyle, classes.width92)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Address
                  </label>
                  <input
                    type="text"
                    name="address"
                    placeholder="Add Your Address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address}
                    className={clsx(classes.inputStyle, classes.width92)}
                  />
                  {errors.address && touched.address && (
                    <div className={clsx(classes.errorStyle, classes.width92)}>
                      {errors.address}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item md={4} xs={12} sm={4} lg={4}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="country"
                    className={clsx(classes.labelStyle, classes.width222)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Country
                  </label>
                  <input
                    type="text"
                    name="country"
                    placeholder="Add Your country Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.country}
                    className={clsx(classes.inputStyle, classes.width222)}
                  />
                  {errors.country && touched.country && (
                    <div className={clsx(classes.errorStyle, classes.width222)}>
                      {errors.country}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item md={4} xs={12} sm={4} lg={4}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="city"
                    className={clsx(classes.labelStyle, classes.width222)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    City
                  </label>

                  <input
                    type="text"
                    name="city"
                    placeholder="Add Your city Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.city}
                    className={clsx(classes.inputStyle, classes.width222)}
                  />
                  {errors.city && touched.city && (
                    <div className={clsx(classes.errorStyle, classes.width222)}>
                      {errors.city}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item md={4} xs={12} sm={4} lg={4}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="postalcode"
                    className={clsx(classes.labelStyle, classes.width222)}
                  >
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                    Postal Code
                  </label>

                  <input
                    type="text"
                    name="postalcode"
                    placeholder="Add Your Postal Code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.postalcode}
                    className={clsx(classes.inputStyle, classes.width222)}
                  />
                  {errors.postalcode && touched.postalcode && (
                    <div className={clsx(classes.errorStyle, classes.width222)}>
                      {errors.postalcode}
                    </div>
                  )}
                </div>
              </Grid>

              <Grid
                item
                container
                justify="center"
                md={12}
                xs={12}
                sm={12}
                lg={12}
              >
                <Grid
                  item
                  md={6}
                  xs={11}
                  sm={12}
                  lg={6}
                  container
                  justify="flex-start"
                >
                  <RoundButton
                    type="submit"
                    onClick={handleSubmit}
                    disabled={
                      !values.firstName ||
                      isSubmitting ||
                      Object.keys(errors).length > 0
                    }
                    className={
                      !values.firstName ||
                      isSubmitting ||
                      Object.keys(errors).length > 0
                        ? classes.disableSubmit
                        : classes.submit
                    }
                  >
                    Submit
                  </RoundButton>
                </Grid>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Stack>
  );
};

export default ArzPayment;
